import Card from 'ui/cards/Card'
import { SecondaryHeading } from 'ui/headings'
import React from 'react'

export function CardWithHeaderAndButtons ({ children, header, buttons }) {
  return (
    <Card>
      <div className='flex items-start justify-between mb-4'>
        <div className='flex items-center'>
          <SecondaryHeading>
            {header}
          </SecondaryHeading>
        </div>
        <div className='flex space-x-2'>
          {buttons}
        </div>
      </div>
      <div className=''>
        {children}
      </div>
    </Card>
  )
}
